import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
      <div className="relative overflow-hidden rounded-lg bg-background-900 px-6 py-12 text-center text-background-50 md:py-16">
        <div className="pointer-events-none absolute inset-0 opacity-20">
          <div className="absolute left-1/4 top-0 h-56 w-56 rounded-full bg-accent-500/60 blur-3xl" />
          <div className="absolute right-1/4 bottom-0 h-56 w-56 rounded-full bg-primary-500/60 blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-2xl">
          <h2 className="font-heading text-2xl leading-tight text-background-50 md:text-3xl">
            有独家情报或精彩投稿？
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
            无论是新游漫画化的第一手消息，还是精彩的联动漫画解读，欢迎联系可游漫画网投稿分享。
          </p>
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="manga-clip whitespace-nowrap bg-primary-500 px-6 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-400"
            >
              投稿咨询
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-background-600 px-6 py-3 text-base font-bold text-background-100 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}